
import {defineComponent, PropType} from 'vue';
import { Tooltip } from 'bootstrap';
import type { ModsType } from '@/types/IModsData'
import DataMixins from "@/mixins/DataMixins";

export default defineComponent({
	name: 'CatalogCardComponent',
    props: {
        data: {
            type: Object as PropType<ModsType>,
            required: true
        },
    },
    mounted() {
      this.initializeTooltips()
    },
    updated() {
      this.initializeTooltips()
    },
    methods: {
      initializeTooltips(): void {
        const tooltipElements : NodeList = document.querySelectorAll(
            `[data-bs-toggle="tooltip-${this.data.id}"]`
        )

        if (tooltipElements) {
          tooltipElements.forEach((el: any) => {
            const tooltipInstance = Tooltip.getInstance(el);

            if (tooltipInstance) {
              tooltipInstance.dispose();
            }
            new Tooltip(el);
          })
        }
      }
    },
    mixins: [DataMixins]
})
